import React, { Component } from 'react';
import './Jogadores.css';
import perfil from '../perfil.png';
import imageCheck from './Image.js';

class Jogadores extends Component {
	state = {
		response: '',
		uncheked: true
	}

	setResponse = (url, res) => {
		this.setState({response: res})
		this.setState({uncheked: false})
	}

	render(){
		const { response } = this.state;
		if(this.props.usuario && this.state.uncheked === true){
			imageCheck('http://healthfy.com.br/dash/img_id/' + this.props.usuario.cpf + '.jpg', this.setResponse)
		}
		return (
			<div>
				{this.props.usuario && 
					<div>
						<img src={response === 'success' ? 'http://healthfy.com.br/dash/img_id/' + this.props.usuario.cpf + '.jpg' : perfil} alt="Avatar" style={{height: 100, float: 'left', 'marginRight': 10}}/>
						<p style={{margin: 0}}><b>Nome</b>: {this.props.usuario.nome}</p>
						<p style={{margin: 0}}><b>Idade</b>: {this.props.usuario.idade} anos</p>
						<p style={{margin: 0}}><b>Peso</b>: {this.props.usuario.peso}kg</p>
						<p style={{margin: 0}}><b>Altura</b>: {this.props.usuario.altura}cm</p>
						<p style={{margin: 0}}><b>IMC</b>: {Math.floor(this.props.usuario.IMC)}</p>
					</div>
				}
			</div>
		)
	}

}

export default Jogadores;



// WEBPACK FOOTER //
// ./src/components/Jogadores.js